import { Alert, AlertDialog, Text } from "@vericus/cadmus-ui";

import { create, useModal } from "@ebay/nice-modal-react";

import * as styles from "./styles.css";

interface AbandonAttemptModalProps {
  onConfirm: () => void;
  remainingAttempts: number;
}

/**
 * Alert dialog to confirm that the student wants to leave the socratic page,
 * which will forfeit their current attempt and response.
 */
export const AbandonAttemptModal = create<AbandonAttemptModalProps>(
  ({ onConfirm, remainingAttempts }: AbandonAttemptModalProps) => {
    const modal = useModal();

    const handleConfirm = () => {
      onConfirm();
      modal.hide();
    };

    return (
      <AlertDialog.Root open={modal.visible}>
        <AlertDialog.Content>
          <AlertDialog.Title asChild>
            <Text kind="headingFour">
              Leaving this page will cause you to lose your current attempt and
              response
            </Text>
          </AlertDialog.Title>
          <AlertDialog.Description asChild>
            <Text kind="bodyLine" color="navy400">
              Are you sure you wish to continue?
            </Text>
          </AlertDialog.Description>
          <Alert size="sm" severity="warning" className={styles.alertCentered}>
            You will have {remainingAttempts}{" "}
            {remainingAttempts === 1 ? "attempt" : "attempts"} left after this.
          </Alert>
          <AlertDialog.Actions
            style={{ gridTemplateColumns: "1fr 1fr", gap: 24 }}
          >
            <AlertDialog.Cancel onClick={modal.remove}>
              No, keep my attempt
            </AlertDialog.Cancel>
            <AlertDialog.Action onClick={handleConfirm}>
              Yes, lose my attempt
            </AlertDialog.Action>
          </AlertDialog.Actions>
        </AlertDialog.Content>
      </AlertDialog.Root>
    );
  }
);
